import { render, staticRenderFns } from "./EditProfilModal.vue?vue&type=template&id=3bc9f7ec&scoped=true"
import script from "./EditProfilModal.vue?vue&type=script&lang=js"
export * from "./EditProfilModal.vue?vue&type=script&lang=js"
import style0 from "./EditProfilModal.vue?vue&type=style&index=0&id=3bc9f7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc9f7ec",
  null
  
)

export default component.exports